import React from 'react';
import { signInURL } from '../../lib/constants';
const SignInLink = () => (React.createElement("div", { className: 'flex' },
    React.createElement("h4", { className: 'pad-right-sm' }, "Have an account?"),
    React.createElement("a", { href: signInURL, title: 'Sign in to your account', tabIndex: 0, "data-ref": 'offer.login-button', style: { color: 'var(--color-blue-darker)' } }, "Sign in to buy")));
export default SignInLink;
